module.exports = __webpack_public_path__ + "static/rom-f455de42686ebe5282e061296f0e7103.png";